import { render, staticRenderFns } from "./LoaderPic.vue?vue&type=template&id=c96e439e&scoped=true&"
import script from "./LoaderPic.vue?vue&type=script&lang=js&"
export * from "./LoaderPic.vue?vue&type=script&lang=js&"
import style0 from "./LoaderPic.vue?vue&type=style&index=0&id=c96e439e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96e439e",
  null
  
)

export default component.exports